import { jsxs as p, Fragment as n, jsx as o } from "react/jsx-runtime";
import { c as f } from "../../index-C7ezJk5b.js";
import { useMemo as u } from "react";
import "../../base-nYmjnkiN.js";
import P from "../../core/hooks/useUuid.js";
import { toPascalCase as _ } from "../../core/utils/string.js";
import { cssX as t, cssTI as g } from "../../core/utils/css.js";
import "react-dom";
import h from "../../components/ProductLogo/ProductLogo.js";
import N from "../../components/Tooltip/Tooltip.js";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const G = ({
  data: c
}) => {
  const {
    appId: l,
    name: r,
    description: i,
    url: d,
    isDisabled: m
  } = c, s = P(), a = {
    className: f(
      t("PlatformProduct"),
      t("PlatformProductsGroup__item")
    ),
    "data-tooltip-id": s,
    "data-testid": g("button", `PlatformProduct${_(r ?? "")}`)
  }, e = u(
    () => /* @__PURE__ */ p(n, { children: [
      /* @__PURE__ */ o(
        h,
        {
          appId: l,
          type: m ? "gs" : "regular",
          className: t("PlatformProduct__icon")
        }
      ),
      /* @__PURE__ */ o("div", { className: t("PlatformProduct__title"), children: r }),
      !!i && /* @__PURE__ */ o(N, { id: s, place: "left", className: t("PlatformProduct__tooltip"), children: /* @__PURE__ */ o("div", { dangerouslySetInnerHTML: { __html: i } }) })
    ] }),
    [r, i, m]
  );
  return m ? /* @__PURE__ */ o("div", { ...a, children: e }) : /* @__PURE__ */ o("a", { href: d, ...a, children: e });
};
export {
  G as NavigationItem
};
